import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { DatePicker, Select, Table } from 'antd';
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/bn_BD';
import 'antd/dist/antd.css';
import ReactSelect from 'react-select';

import dayjs from "dayjs";

import swal from "sweetalert";
import { useAuth } from '../../../context/AuthContext';
import {
    getSingleCaseViewApi,
    getCaseCategoriesApi,
    getLawOfficersApi,
    getJusticeNamesApi,
    getDistrictsApi,
    getCourtTypesApi,
    getCaseTypesByCategoryApi,
    getAssignResponsibleOfficersApi,
    assignLawOfficerApi,
    deleteAssignLawOfficerApi,
    getLawOfficerNamesByOfficerApi,
    getPlaintiffsByCaseEntryApi,
    createPlaintiffApi,
    deletePlaintiffApi,
    getDefendantsByCaseEntryApi,
    createDefendantApi,
    deleteDefendantApi,
    createLawOfficerNameApi,
    updateHighCourtEntryApi,
} from '../../../api/master.api';

const { Option } = Select;
const ThreeMemberCaseUpdateForm = () => {
    const { caseId } = useParams();
    const navigate = useNavigate();
    const { user } = useAuth();
    // console.log("caseId")
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({

        case_category: '',
        case_type: '',
        case_number: '',
        case_year: '',
        filing_date: '',
        petitioner_count: '',
        case_description: '',
        case_cost: '',
        court_order_received: '',
        stay_order_des: '',
        case_type_name: '',
        category_name: '',
        ha_case_court_name: '',
        ha_case_justice_name: '',
        important_case: '',
        rule_issue_date: ''


    });
    const [errors, setErrors] = useState({});
    const [courtCategoryOptions, setCourtCategoryOptions] = useState([]);
    const [caseTypeOptions, setCaseTypeOptions] = useState([]);
    const [justiceOptions, setJusticeOptions] = useState([]);
    const [officerOptions, setOfficerOptions] = useState([]);
    const [respondentOptions, setRespondentOptions] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [courtTypes, setCourtTypes] = useState([]);
    const [selectedCourtType, setSelectedCourtType] = useState(null);
    const [assignLawOfficerData, setAssignLawOfficerData] = useState([]);
    const [plaintiffsData, setPlaintiffsData] = useState([]);
    const [defendantsData, setDefendantsData] = useState([]);
    const [assignLawLoading, setAssignLawLoading] = useState(false);
    const [plaintiffLoading, setPlaintiffLoading] = useState(false);
    const [defendantLoading, setDefendantLoading] = useState(false);
    // State for new related law officer modals
    const [newRelatedLawOfficerName, setNewRelatedLawOfficerName] = useState({
        law_officer_id: '',
        officer_name: '',
        officer_mobile: '',
        officer_address: ''
    });

    // Fetch existing case data - FIXED VERSION
    useEffect(() => {
        const fetchCaseData = async () => {
            try {
                // setLoading(false);
               
                const res = await getSingleCaseViewApi(caseId);
                const caseData = res.data?.data;
                if (caseData) {

                    // Helper function to convert DD/MM/YYYY to YYYY-MM-DD
                    const convertDateFormat = (dateStr) => {
                        if (!dateStr) return '';
                        // If already in YYYY-MM-DD format, return as is
                        if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
                            return dateStr;
                        }
                        // Convert DD/MM/YYYY to YYYY-MM-DD
                        if (dateStr.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                            const [day, month, year] = dateStr.split('/');
                            return `${year}-${month}-${day}`;
                        }
                        return dateStr;
                    };



                    // Helper function to safely convert to string
                    const safeToString = (value) => {
                        if (value === null || value === undefined) return '';
                        return value.toString();
                    };

                    // Transform the data to match form structure
                    const transformedData = {

                        case_category: safeToString(caseData.category_id || caseData.case_category || ''),
                        case_type: safeToString(caseData.case_type_id || caseData.case_type || ''),
                        case_number: caseData.case_number || '',
                        case_year: caseData.case_year || '',
                        filing_date: convertDateFormat(caseData.filing_date) || '',
                        petitioner_count: safeToString(caseData.petitioner_count || ''),
                        case_description: caseData.case_description || '',
                        case_cost: caseData.case_cost || '',
                        court_order_received: caseData.court_order_received || '',
                        stay_order_des: caseData.stay_order_des || '',
                        case_type_name: caseData.case_type_name || '',
                        category_name: caseData.category_name || '',
                        ha_case_court_name: caseData.ha_case_court_name || '',
                        ha_case_justice_name: caseData.ha_case_justice_name || '',
                        important_case: caseData.important_case || '',
                        rule_issue_date: convertDateFormat(caseData.rule_issue_date) || '',


                    };

                    setFormData(transformedData);

                    // Set court type if exists
                    if (caseData.court_type_id) {
                        setSelectedCourtType(caseData.court_type_id);
                    }
                }
            } catch (err) {
                console.error("Error fetching case data:", err);
                swal({
                    title: "ত্রুটি",
                    text: "মামলার তথ্য লোড করতে সমস্যা হয়েছে",
                    icon: "error",
                    button: "ঠিক আছে",
                });
                navigate('/report/district-court/all-case');
            } finally {
                setLoading(false);
            }
        };

        if (caseId) {
            fetchCaseData();
        }
    }, [caseId]);

    // Fetch all necessary options
    useEffect(() => {
        const fetchAllOptions = async () => {
            try {
                const categoriesRes = await getCaseCategoriesApi(1, 100, '');
                const catItems = categoriesRes.data?.data?.items ?? [];
                setCourtCategoryOptions(catItems.map(item => ({
                    value: item.category_id,
                    label: item.category_name,
                })));

                const officersRes = await getLawOfficersApi(1, 100, '');
                const offItems = officersRes.data?.data?.items ?? [];
                setOfficerOptions(offItems.map(item => ({
                    value: item.law_officer_id,
                    label: item.law_officer_name,
                })));

                const justicesRes = await getJusticeNamesApi(1, 100, '');
                const jusItems = justicesRes.data?.data?.items ?? [];
                setJusticeOptions(jusItems.map(item => ({
                    value: item.justice_id,
                    label: item.justice_name,
                })));

                const districtsRes = await getDistrictsApi();
                const distRows = districtsRes.data?.data ?? [];
                setDistricts(distRows.map(item => ({
                    value: item.district_id,
                    label: `${item.district_name} (${item.division_name})`,
                })));

                const courtTypesRes = await getCourtTypesApi();
                const ctRows = courtTypesRes.data?.data ?? [];
                setCourtTypes(ctRows.map(item => ({
                    value: item.court_type_id,
                    label: item.court_type_name,
                })));


            } catch (err) {
                console.error("Error fetching options:", err);
            }
        };

        fetchAllOptions();
    }, []);

    // Fetch case types when category changes
    useEffect(() => {
        const getCaseTypes = async () => {
            if (!formData.case_category) {
                setCaseTypeOptions([]);
                return;
            }

            try {
                const res = await getCaseTypesByCategoryApi(formData.case_category);
                const rows = res.data?.data ?? [];

                const options = rows.map((item) => ({
                    value: item.case_type_id,
                    label: item.case_type_name,
                }));
                setCaseTypeOptions(options);
            } catch (err) {
                console.error(err);
                setCaseTypeOptions([]);
            }
        };

        getCaseTypes();
    }, [formData.case_category]);



    useEffect(() => {
        const getCaseTypes = async () => {
          
            try {
                const res = await getAssignResponsibleOfficersApi(parseInt(caseId, 10));
                const rows = res.data?.data ?? [];
                setAssignLawOfficerData(Array.isArray(rows) ? rows : []);
                setAssignLawLoading(false);

            } catch (err) {
                console.error(err);

            }
        };

        getCaseTypes();
    }, [assignLawLoading]);

    // Fetch plaintiffs data
    useEffect(() => {
        const fetchPlaintiffs = async () => {
          
            try {
                const res = await getPlaintiffsByCaseEntryApi(parseInt(caseId, 10));
                const rows = res.data?.data ?? [];
                setPlaintiffsData(Array.isArray(rows) ? rows : []);
                setPlaintiffLoading(false);

            } catch (err) {
                console.error(err);
                setPlaintiffLoading(false);
            }
        };

        if (caseId) {
            fetchPlaintiffs();
        }
    }, [plaintiffLoading]);

    // Fetch defendants data
    useEffect(() => {
        const fetchDefendants = async () => {
            try {
                const res = await getDefendantsByCaseEntryApi(parseInt(caseId, 10));
                const rows = res.data?.data ?? [];
                setDefendantsData(Array.isArray(rows) ? rows : []);
                setDefendantLoading(false);

            } catch (err) {
                console.error(err);
                setDefendantLoading(false);
            }
        };

        if (caseId) {
            fetchDefendants();
        }
    }, [defendantLoading]);

    const engToBangla = (num) => {
        const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
        return num.toString().split('').map(d => banglaDigits[d]).join('');
    };

    const petitionerCountOptions = Array.from({ length: 1000 }, (_, i) => ({
        value: (i + 1).toString(),
        label: engToBangla(i + 1),
    }));

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
        setErrors(prev => {
            const next = { ...prev };
            if (next[field]) {
                delete next[field];
            }
            return next;
        });
    };

    const handleDateChange = (field, date) => {
        if (date && moment.isMoment(date) && date.isValid()) {
            handleInputChange(field, date.format('YYYY-MM-DD'));
        } else if (date === null) {
            handleInputChange(field, '');
        } else {
            handleInputChange(field, '');
        }
    };

    const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };

    // Helper functions for dynamic fields

    const addOfficer = async () => {
        try {
            const response = await assignLawOfficerApi({
                case_entry_id: parseInt(caseId, 10),
                officer_name_id: parseInt(officersId.officer_name_id, 10),
                law_officer_id: parseInt(officersId.law_officer_id, 10),
            });

            if (response.data?.success) {

                // Refresh officer name options for all officers with the same law_officer_id
                setAssignLawLoading(true);
                setOfficerId({
                    law_officer_id: '',
                    officer_name_id: '',
                });

            }
        } catch (error) {
            console.error('Error adding related law officer name:', error);
            swal({
                title: "ত্রুটি",
                text: "সংশ্লিষ্ট আইন কর্মকর্তার নাম যোগ করতে সমস্যা হয়েছে",
                icon: "error",
                button: "ঠিক আছে",
            });
        }
    };

    const removeOfficer = (id) => {
        console.log(id);
        deleteAssignLawOfficerApi(id)
            .then((response) => {
                if (response.data?.success) {
                    // Refresh officer name options for all officers with the same law_officer_id
                    setAssignLawLoading(true);
                }
            })
            .catch((error) => {
                console.error('Error removing related law officer name:', error);
            });
    };

    // Delete officer from table

    const [assignNewOfficersData, setAssignNewOfficersData] = useState([]);
    const [officersId, setOfficerId] = useState({
        law_officer_id: '',
        officer_name_id: '',
    });

    // State for plaintiff and defendant form inputs
    const [plaintiffInput, setPlaintiffInput] = useState({
        name: '',
        mobile: '',
        address: ''
    });
    const [defendantInput, setDefendantInput] = useState({
        name: '',
        mobile: '',
        address: ''
    });

    const updateOfficer = async (value) => {
        setAssignNewOfficersData([]);
        setOfficerId({ law_officer_id: value });
        try {
            const res = await getLawOfficerNamesByOfficerApi(value);
            if (res.data?.success) {
                const rows = res.data?.data ?? [];
                const options = rows.map((item) => ({
                    value: item.officer_name_id,
                    label: item.officer_name,
                }));
                setAssignNewOfficersData(options);
            }
        } catch (err) {
            console.error(err);
        }



    };

    // Add plaintiff via API
    const addPlaintiff = async () => {
        if (!plaintiffInput.name) {
            swal({
                title: "ত্রুটি",
                text: "বাদীর নাম আবশ্যক",
                icon: "error",
                button: "ঠিক আছে",
            });
            return;
        }

        try {
            const response = await createPlaintiffApi({
                case_entry_id: parseInt(caseId, 10),
                plaintiff_name: plaintiffInput.name,
                contact_no: plaintiffInput.mobile || '',
                address: plaintiffInput.address || '',
            });

            if (response.data?.success) {
                setPlaintiffLoading(true);
                setPlaintiffInput({
                    name: '',
                    mobile: '',
                    address: ''
                });

            }
        } catch (error) {
            console.error('Error adding plaintiff:', error);

        }
    };

    // Remove plaintiff via API
    const removePlaintiff = (id) => {
        deletePlaintiffApi(id)
            .then((response) => {
                if (response.data?.success) {
                    setPlaintiffLoading(true);

                }
            })
            .catch((error) => {
                console.error('Error removing plaintiff:', error);

            });
    };

    // Add defendant via API
    const addDefendant = async () => {
        if (!defendantInput.name) {
            swal({
                title: "ত্রুটি",
                text: "বিবাদীর নাম আবশ্যক",
                icon: "error",
                button: "ঠিক আছে",
            });
            return;
        }

        try {
            const response = await createDefendantApi({
                case_entry_id: parseInt(caseId, 10),
                defendant_name: defendantInput.name,
                contact_no: defendantInput.mobile || '',
                address: defendantInput.address || '',
            });

            if (response.data?.success) {
                setDefendantLoading(true);
                setDefendantInput({
                    name: '',
                    mobile: '',
                    address: ''
                });

            }
        } catch (error) {
            console.error('Error adding defendant:', error);

        }
    };

    // Remove defendant via API
    const removeDefendant = (id) => {
        deleteDefendantApi(id)
            .then((response) => {
                if (response.data?.success) {
                    setDefendantLoading(true);

                }
            })
            .catch((error) => {
                console.error('Error removing defendant:', error);

            });
    };


    // Handle court type change
    const handleCourtTypeChange = (value, option) => {
        if (value === 'new') {
            setSelectedCourtType(null);
            setFormData(prev => ({
                ...prev,
                other_court: '',
                court_type_id: null
            }));
        } else {
            setSelectedCourtType(value);
            setFormData(prev => ({
                ...prev,
                other_court: option?.label || '',
                court_type_id: value
            }));
        }
    };

    // Handle submit related law officer name
    const handleSubmitRelatedLawOfficerName = async (e) => {
        e.preventDefault();
        try {
            const response = await createLawOfficerNameApi({
                officer_name: newRelatedLawOfficerName.officer_name,
                officer_mobile: newRelatedLawOfficerName.officer_mobile,
                officer_address: newRelatedLawOfficerName.officer_address,
                law_officer_id: parseInt(newRelatedLawOfficerName.law_officer_id, 10),
            });

            if (response.data?.success) {
                swal({
                    title: "সফল",
                    text: "সংশ্লিষ্ট আইন কর্মকর্তার নাম সফলভাবে যোগ করা হয়েছে",
                    icon: "success",
                    button: "ঠিক আছে",
                });

                // Refresh officer name options for all officers with the same law_officer_id
                const officerId = newRelatedLawOfficerName.law_officer_id;
                if (officerId) {
                    try {
                        const res = await getLawOfficerNamesByOfficerApi(officerId);
                        if (res.data?.success) {
                            const rows = res.data?.data ?? [];
                            const options = rows.map((item) => ({
                                value: item.officer_name_id,
                                label: item.officer_name,
                            }));

                            // Update all officers with this law_officer_id
                            setFormData(prev => ({
                                ...prev,
                                relatedOfficers: prev.relatedOfficers.map(officer =>
                                    officer.officer === officerId
                                        ? { ...officer, nameOptions: options }
                                        : officer
                                )
                            }));
                        }
                    } catch (err) {
                        console.error('Error refreshing officer name options:', err);
                    }
                }

                setNewRelatedLawOfficerName({
                    law_officer_id: '',
                    officer_name: '',
                    officer_mobile: '',
                    officer_address: ''
                });
                window.$("#add_related_law_officer_name").modal("hide");
            }
        } catch (error) {
            console.error('Error adding related law officer name:', error);
            swal({
                title: "ত্রুটি",
                text: "সংশ্লিষ্ট আইন কর্মকর্তার নাম যোগ করতে সমস্যা হয়েছে",
                icon: "error",
                button: "ঠিক আছে",
            });
        }
    };

    // Table columns definitions with delete functionality
    const officerColumns = [
        {
            title: 'সংশ্লিষ্ট আইন কর্মকর্তা',
            dataIndex: 'law_officer_name',
            key: 'officer',

        },
        {
            title: 'সংশ্লিষ্ট আইন কর্মকর্তার নাম',
            dataIndex: 'officer_name',
            key: 'name',

        },
        {
            title: 'কার্যক্রম',
            key: 'action',
            render: (_, record, index) => (
                <button
                    type="button"
                    onClick={() => removeOfficer(record.officer_name_dtl_id)}
                    style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#dc2626')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#ef4444')}
                >
                    <i className="fas fa-trash" style={{ fontSize: '12px' }}></i>
                </button>
            ),
        },
    ];

    const plaintiffColumns = [
        {
            title: 'বাদীর নাম',
            dataIndex: 'plaintiff_name',
            key: 'name',
            render: (text) => text || '-'
        },
        {
            title: 'বাদীর মোবাইল নম্বর',
            dataIndex: 'contact_no',
            key: 'mobile',
            render: (text) => text || '-'
        },
        {
            title: 'বাদীর ঠিকানা',
            dataIndex: 'address',
            key: 'address',
            render: (text) => text || '-'
        },
        {
            title: 'কার্যক্রম',
            key: 'action',
            render: (_, record) => (
                <button
                    type="button"
                    onClick={() => removePlaintiff(record.plaintiff_id)}
                    style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#dc2626')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#ef4444')}
                >
                    <i className="fas fa-trash" style={{ fontSize: '12px' }}></i>
                </button>
            ),
        },
    ];

    const defendantColumns = [
        {
            title: 'বিবাদীর নাম',
            dataIndex: 'defendant_name',
            key: 'name',
            render: (text) => text || '-'
        },
        {
            title: 'বিবাদীর মোবাইল নম্বর',
            dataIndex: 'contact_no',
            key: 'mobile',
            render: (text) => text || '-'
        },
        {
            title: 'বিবাদীর ঠিকানা',
            dataIndex: 'address',
            key: 'address',
            render: (text) => text || '-'
        },
        {
            title: 'কার্যক্রম',
            key: 'action',
            render: (_, record) => (
                <button
                    type="button"
                    onClick={() => removeDefendant(record.defendant_id)}
                    style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#ef4444',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                    onMouseOver={(e) => (e.target.style.backgroundColor = '#dc2626')}
                    onMouseOut={(e) => (e.target.style.backgroundColor = '#ef4444')}
                >
                    <i className="fas fa-trash" style={{ fontSize: '12px' }}></i>
                </button>
            ),
        },
    ];

    // Main submit handler - FIXED
    const handleSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();

        try {

            const finalData = {
                ...formData,
                updated_by: user?.id,
                case_entry_id: parseInt(caseId, 10),
                court_type_id: 8 // Default to district court
            };

            console.log("Final update payload:", finalData);

            const res = await updateHighCourtEntryApi(parseInt(caseId, 10), finalData);

            if (res.data?.success) {
                swal({
                    title: "সফল",
                    text: "মামলা সফলভাবে আপডেট করা হয়েছে",
                    icon: "success",
                    button: "ঠিক আছে",
                });
                window.location.reload();
                // navigate('/report/district-court/all-case');
            } else {
                throw new Error(res.data?.message || "Update failed");
            }
        } catch (err) {
            console.error("Update failed:", err);
            swal({
                title: "ত্রুটি",
                text: "আপডেট করতে সমস্যা হয়েছে",
                icon: "error",
                button: "ঠিক আছে",
            });
        }
    };

    // Styles (same as your original)
    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e5e7eb'
        },
        header: {
            backgroundColor: '#f3f4f6',
            padding: '12px 16px',
            borderBottom: '1px solid #e5e7eb'
        },
        headerTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
            color: '#1f2937',
            margin: 0
        },
        formInput: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px'
        },
        datePicker: {
            width: '100%',
            height: '36px'
        },
        searchableSelect: {
            width: '100%',
            height: '36px'
        },
        textarea: {
            width: '100%',
            padding: '8px',
            border: '1px solid #d1d5db',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'none'
        },
        label: {
            display: 'block',
            fontSize: '14px',
            fontWeight: '500',
            marginBottom: '4px'
        },
        removeButton: {
            width: '32px',
            height: '32px',
            backgroundColor: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        addButton: {
            marginTop: '8px',
            padding: '4px 12px',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        helpIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#3b82f6',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        warningIcon: {
            width: '16px',
            height: '16px',
            backgroundColor: '#ef4444',
            color: 'white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            marginLeft: '8px'
        },
        uploadSection: {
            backgroundColor: '#ecfeff',
            border: '1px solid #67e8f9',
            padding: '12px',
            marginBottom: '16px'
        },
        submitButton: {
            padding: '8px 24px',
            backgroundColor: '#0d9488',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        greenAddButton: {
            width: '24px',
            height: '24px',
            backgroundColor: '#16a34a',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s'
        },
        errorText: {
            color: '#b91c1c',
            fontSize: '12px',
            marginTop: '4px'
        },
        warningBox: {
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            padding: '12px',
            marginBottom: '16px',
            fontSize: '14px',
            color: '#b91c1c'
        },
        tableSection: {
            marginTop: '16px',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '16px',
            backgroundColor: '#f9fafb'
        },
        tableTitle: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '12px',
            paddingBottom: '8px',
            borderBottom: '2px solid #3b82f6'
        }
    };

    if (loading) {
        return (
            <div className='page-wrapper'>
                <div style={styles.container}>
                    <div style={styles.header}>
                        <h1 style={styles.headerTitle}>THREE-MEMBER ARBITRAL TRIBUNAL মামলা সংশোধন</h1>
                    </div>
                    <div style={{ padding: '32px', textAlign: 'center' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">লোড হচ্ছে...</span>
                        </div>
                        <p className="mt-2">মামলার তথ্য লোড হচ্ছে...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='page-wrapper'>
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <h1 style={styles.headerTitle}>THREE-MEMBER ARBITRAL TRIBUNAL মামলা সংশোধন</h1>
                </div>

                {/* <div style={styles.warningBox}>
                    (মামলার বিষয়বস্তুর সাথে সরাসরি সংশ্লিষ্ট/ মূল রেসপন্ডেন্ট অফিস কর্তৃক মামলা এন্ট্রি করতে হবে। মামলার রেসপন্ডেন্ট তালিকাভুক্ত হলেও বিষয়বস্তুর সাথে সংশ্লিষ্টতা না থাকলে উক্ত মামলা এন্ট্রি হতে বিরত থাকুন।)*
                </div> */}

                <div style={{ backgroundColor: 'white', textAlign: 'left', padding: '32px' }}>
                    {/* Court Type Section */}
                    <div className="row mb-3">



                        <div className="col-md-4">
                            <label style={styles.label}>মামলার ক্যাটেগরি {formData.category_name ? `(${formData.category_name})` : ''}</label>
                            <Select
                                style={styles.searchableSelect}
                                placeholder="--- নির্বাচন করুন ---"
                                // value={formData.case_category || undefined}
                                onChange={(value) => handleInputChange('case_category', value)}
                                showSearch
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                            >
                                {courtCategoryOptions?.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>মামলার শ্রেণী/কেস-টাইপ {formData.case_type_name ? `(${formData.case_type_name})` : ''}</label>
                            <Select
                                style={styles.searchableSelect}
                                placeholder="--- নির্বাচন করুন ---"
                                // value={formData.case_type || undefined}
                                onChange={(value) => handleInputChange('case_type', value)}
                                showSearch
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                            >
                                {caseTypeOptions?.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>মামলার নং {formData.case_number ? `(${formData.case_number})` : ''}</label>
                            <input
                                type="text"
                                placeholder="(Type digits in English)"
                                style={styles.formInput}
                                value={formData.case_number}
                                onChange={(e) => handleInputChange('case_number', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">

                        <div className="col-md-4">
                            <label style={styles.label}>
                                আদালতের নাম
                            </label>
                            <input
                                type="text"
                                style={styles.formInput}
                                value={formData.ha_case_court_name}
                                onChange={(e) => handleInputChange('ha_case_court_name', e.target.value)}
                            />
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>
                                Justice Name
                            </label>
                            <input
                                type="text"
                                style={styles.formInput}
                                value={formData.ha_case_justice_name}
                                onChange={(e) => handleInputChange('ha_case_justice_name', e.target.value)}
                            />
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>গুরুত্বপূর্ণ মামলা ({formData.important_case == '1' ? 'হ্যাঁ' : 'না'})</label>

                            <select
                                className="border p-2 rounded"
                                style={styles.formInput}
                                // value={formData.important_case}
                                onChange={(e) =>
                                    handleInputChange("important_case", e.target.value)
                                }
                            >
                                <option value="">--- নির্বাচন করুন ---</option>
                                <option value="1">হ্যাঁ</option>
                                <option value="0">না</option>
                            </select>
                        </div>
                    </div>



                    {/* Filing Date and Justice Names */}
                    <div className="row mb-3">
                        <div className="col-md-4">

                            <label style={styles.label}>বছর {formData.case_year ? `(${formData.case_year})` : ''}</label>

                            <DatePicker
                                picker="year"
                                placeholder="--- নির্বাচন করুন ---"
                                style={{ width: "100%" }}
                                // value={formData.case_year ? dayjs(formData.case_year, "YYYY") : null}
                                onChange={(date, dateString) => handleInputChange("case_year", dateString)}
                            />
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>মামলা দায়েরের তারিখ {formData.filing_date && (
                                <span style={{ color: '#666', fontSize: '12px', marginLeft: '8px', fontWeight: 'normal' }}>
                                    ({moment(formData.filing_date).format('DD/MM/YYYY')})
                                </span>
                            )}</label>
                            <DatePicker
                                style={styles.datePicker}
                                placeholder="দিন/মাস/বছর"
                                value={getSafeDateValue(formData.filing_date)}
                                onChange={(date) => handleDateChange('filing_date', date)}
                                format="DD/MM/YYYY"
                                locale={locale}
                                allowClear={true}
                                inputReadOnly={false}
                                showToday={true}
                                showTime={false}
                            />
                        </div>
                        <div className="col-md-4">
                            <label style={styles.label}>রুল ইস্যুর তারিখ {formData.rule_issue_date && (
                                <span style={{ color: '#666', fontSize: '12px', marginLeft: '8px', fontWeight: 'normal' }}>
                                    ({moment(formData.rule_issue_date).format('DD/MM/YYYY')})
                                </span>
                            )}</label>
                            <DatePicker
                                style={styles.datePicker}
                                placeholder="দিন/মাস/বছর"
                                value={getSafeDateValue(formData.rule_issue_date)}
                                onChange={(date) => handleDateChange('rule_issue_date', date)}
                                format="DD/MM/YYYY"
                                locale={locale}
                                allowClear={true}
                                inputReadOnly={false}
                                showToday={true}
                                showTime={false}
                            />
                        </div>


                        <div className="col-md-4">
                            <label style={styles.label}>মোট বাদীর সংখ্যা</label>
                            <Select
                                style={styles.searchableSelect}
                                placeholder="মোট বাদীর সংখ্যা নির্বাচন করুন"
                                value={formData.petitioner_count || undefined}
                                onChange={(value) => handleInputChange('petitioner_count', value)}
                                showSearch
                                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                allowClear
                            >
                                {petitionerCountOptions?.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>


                        <div style={{ marginBottom: '16px', marginTop: '16px' }}>
                            <label style={styles.label}>বিষয়বস্তু(সংক্ষিপ্ত)</label>
                            <textarea style={{ ...styles.textarea, height: '128px' }} value={formData.case_description} onChange={(e) => handleInputChange('case_description', e.target.value)} />
                        </div>
                        <div style={{ marginBottom: '16px' }}>
                            <p style={{ fontSize: '14px', marginBottom: '8px' }}>
                                মামলা সংশ্লিষ্ট অর্থের পরিমান(যদি আর্থিক সংশ্লেষ থাকে বা সরকারি অর্থ ব্যয়/প্রদানের বিষয় থাকে অথবা মামলাভুক্ত সম্পত্তির সম্ভাব্য মূল্য ইত্যাদি)
                            </p>
                            <input type="text" style={styles.formInput} value={formData.case_cost} onChange={(e) => handleInputChange('case_cost', e.target.value)} />
                        </div>

                        <div style={{ marginBottom: '16px' }}>
                            <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '8px' }}>স্থগিতাদেশ/স্থিতাবস্থা/অন্তর্বর্তীকালীন আদেশ প্রদান করা হয়েছে কিনা?</p>
                            <div style={{ display: 'flex', gap: '24px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                                    <input type="checkbox" checked={formData.court_order_received === 'yes'} onChange={() => handleInputChange('court_order_received', formData.court_order_received === 'yes' ? '' : 'yes')} style={{ marginRight: '8px' }} />
                                    হ্যাঁ
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                                    <input type="checkbox" checked={formData.court_order_received === 'no'} onChange={() => handleInputChange('court_order_received', formData.court_order_received === 'no' ? '' : 'no')} style={{ marginRight: '8px' }} />
                                    না
                                </label>
                                <label style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                                    <input type="checkbox" checked={formData.court_order_received === 'not_applicable'} onChange={() => handleInputChange('court_order_received', formData.court_order_received === 'not_applicable' ? '' : 'not_applicable')} style={{ marginRight: '8px' }} />
                                    প্রযোজ্য নয়
                                </label>
                            </div>
                            {formData.court_order_received === 'yes' && (
                                <div style={{ marginBottom: '16px' }}>
                                    <label style={styles.label}>স্থগিতাদেশের সংক্ষিপ্ত বিবরণ</label>
                                    <textarea style={{ ...styles.textarea, height: '128px' }} value={formData.stay_order_des} onChange={(e) => handleInputChange('stay_order_des', e.target.value)} />
                                </div>
                            )}
                        </div>
                        {/* Submit Button */}
                        <div className="text-center mt-4 mb-4">
                            <button
                                type="submit"
                                style={styles.submitButton}
                                onMouseOver={(e) => e.target.style.backgroundColor = '#0f766e'}
                                onMouseOut={(e) => e.target.style.backgroundColor = '#0d9488'}
                                onClick={handleSubmit}
                            >
                                আপডেট করুন
                            </button>
                        </div>

                    </div>

                    {/* Rest of your form sections (Related Officers, Plaintiffs, Defendants, etc.) */}
                    {/* Include all the other sections from your original form here */}
                    {/* They should work the same way as in your create form */}

                    {/* Related Officers Section with Table */}
                    <div style={{ marginBottom: '16px' }} className="border p-2">
                        <div className="row mb-2">
                            <div className="col-md-6">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    সংশ্লিষ্ট আইন কর্মকর্তা
                                </label>
                            </div>
                            <div className="col-md-6">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    সংশ্লিষ্ট আইন কর্মকর্তার নাম
                                    {/* <button
                                        type="button"
                                        className="bg-success text-white ms-2"
                                        onClick={() => window.$("#add_related_law_officer_name").modal("show")}
                                        style={styles.addButton}
                                        title="নতুন সংশ্লিষ্ট আইন কর্মকর্তার নাম যোগ করুন"
                                    >
                                        <i className="fa fa-plus" style={{ fontSize: '14px' }}></i>
                                    </button> */}
                                </label>
                            </div>
                        </div>


                        <div className="row mb-2">
                            <div className="col-md-6">
                                <Select
                                    style={styles.searchableSelect}
                                    placeholder="--- নির্বাচন করুন ---"

                                    onChange={(value) => updateOfficer(value)}
                                    showSearch
                                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    allowClear
                                >
                                    {officerOptions?.map((option) => (
                                        <Option key={option.value} value={option.value}>
                                            {option.label}
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className="col-md-6">
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <Select
                                        style={{ ...styles.searchableSelect, flex: '1' }}
                                        placeholder="--- নির্বাচন করুন ---"

                                        onChange={(value) =>
                                            setOfficerId((prev) => ({
                                                ...prev,
                                                officer_name_id: value,
                                            }))
                                        }
                                        showSearch
                                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                        allowClear
                                    >
                                        {(assignNewOfficersData || [])?.map((option) => (
                                            <Option key={option.value} value={option.value}>
                                                {option.label}
                                            </Option>
                                        ))}
                                    </Select>

                                </div>
                            </div>
                        </div>

                        <button type="button" onClick={addOfficer} className="bg-success" style={styles.addButton}>
                            যোগ করুন
                        </button>

                        {/* Officers Table */}
                        <div style={styles.tableSection}>
                            <div style={styles.tableTitle}>সংশ্লিষ্ট আইন কর্মকর্তাদের তালিকা</div>
                            <Table
                                columns={officerColumns}
                                dataSource={assignLawOfficerData?.map((officer, index) => ({
                                    ...officer,
                                    key: index
                                }))}
                                pagination={false}
                                size="small"
                                locale={{ emptyText: 'কোন তথ্য পাওয়া যায়নি' }}
                            />
                        </div>
                    </div>

                    {/* Plaintiff Section - Single form with Table (like Related Officers) */}
                    <div style={{ marginBottom: '16px' }} className="border p-2">
                        <div className="row mb-2">
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বাদীর নাম
                                </label>
                            </div>
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বাদীর মোবাইল নম্বর
                                </label>
                            </div>
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বাদীর ঠিকানা
                                </label>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" নাম"
                                    value={plaintiffInput.name}
                                    onChange={(e) => setPlaintiffInput(prev => ({ ...prev, name: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" মোবাইল নম্বর"
                                    value={plaintiffInput.mobile}
                                    onChange={(e) => setPlaintiffInput(prev => ({ ...prev, mobile: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" ঠিকানা"
                                    value={plaintiffInput.address}
                                    onChange={(e) => setPlaintiffInput(prev => ({ ...prev, address: e.target.value }))}
                                />
                            </div>
                        </div>

                        <button type="button" onClick={addPlaintiff} className="bg-success" style={styles.addButton}>
                            যোগ করুন
                        </button>

                        {/* Plaintiffs Table */}
                        <div style={styles.tableSection}>
                            <div style={styles.tableTitle}>বাদীদের তালিকা</div>
                            <Table
                                columns={plaintiffColumns}
                                dataSource={plaintiffsData?.map((plaintiff, index) => ({
                                    ...plaintiff,
                                    key: index
                                }))}
                                pagination={false}
                                size="small"
                                locale={{ emptyText: 'কোন তথ্য পাওয়া যায়নি' }}
                            />
                        </div>
                    </div>

                    {/* Defendant Section - Single form with Table (like Related Officers) */}
                    <div style={{ marginBottom: '16px' }} className="border p-2">
                        <div className="row mb-2">
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বিবাদীর নাম
                                </label>
                            </div>
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বিবাদীর মোবাইল নম্বর
                                </label>
                            </div>
                            <div className="col-md-4">
                                <label style={{ ...styles.label, display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                                    বিবাদীর ঠিকানা
                                </label>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" নাম"
                                    value={defendantInput.name}
                                    onChange={(e) => setDefendantInput(prev => ({ ...prev, name: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" মোবাইল নম্বর"
                                    value={defendantInput.mobile}
                                    onChange={(e) => setDefendantInput(prev => ({ ...prev, mobile: e.target.value }))}
                                />
                            </div>
                            <div className="col-md-4">
                                <textarea
                                    style={{ ...styles.textarea, height: '40px' }}
                                    placeholder=" ঠিকানা"
                                    value={defendantInput.address}
                                    onChange={(e) => setDefendantInput(prev => ({ ...prev, address: e.target.value }))}
                                />
                            </div>
                        </div>

                        <button type="button" onClick={addDefendant} className="bg-success" style={styles.addButton}>
                            যোগ করুন
                        </button>

                        {/* Defendants Table */}
                        <div style={styles.tableSection}>
                            <div style={styles.tableTitle}>বিবাদীদের তালিকা</div>
                            <Table
                                columns={defendantColumns}
                                dataSource={defendantsData?.map((defendant, index) => ({
                                    ...defendant,
                                    key: index
                                }))}
                                pagination={false}
                                size="small"
                                locale={{ emptyText: 'কোন তথ্য পাওয়া যায়নি' }}
                            />
                        </div>
                    </div>










                </div>

                {/* Add Related Law Officer Name Modal */}
                <div
                    id="add_related_law_officer_name"
                    className="modal custom-modal fade"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">নতুন সংশ্লিষ্ট আইন কর্মকর্তার নাম যোগ করুন</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                </button>
                            </div>
                            <div className="modal-body text-start">
                                <form onSubmit={handleSubmitRelatedLawOfficerName}>
                                    <div className="row">
                                        <div className="mb-3">
                                            <label
                                                htmlFor="law_officer_select"
                                                className="form-label fw-bold small"
                                            >
                                                সংশ্লিষ্ট আইন কর্মকর্তা *
                                            </label>
                                            <ReactSelect
                                                options={officerOptions}
                                                onChange={(selectedOption) => setNewRelatedLawOfficerName({
                                                    ...newRelatedLawOfficerName,
                                                    law_officer_id: selectedOption?.value || ''
                                                })}
                                                placeholder="নির্বাচন করুন"
                                                isSearchable
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label
                                                htmlFor="officer_name"
                                                className="form-label fw-bold small"
                                            >
                                                কর্মকর্তার নাম *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="officer_name"
                                                placeholder="কর্মকর্তার নাম"
                                                value={newRelatedLawOfficerName.officer_name}
                                                onChange={(e) => setNewRelatedLawOfficerName({
                                                    ...newRelatedLawOfficerName,
                                                    officer_name: e.target.value
                                                })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label
                                                htmlFor="officer_mobile"
                                                className="form-label fw-bold small"
                                            >
                                                মোবাইল নম্বর *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="officer_mobile"
                                                placeholder="মোবাইল নম্বর"
                                                value={newRelatedLawOfficerName.officer_mobile}
                                                onChange={(e) => setNewRelatedLawOfficerName({
                                                    ...newRelatedLawOfficerName,
                                                    officer_mobile: e.target.value
                                                })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label
                                                htmlFor="officer_address"
                                                className="form-label fw-bold small"
                                            >
                                                ঠিকানা *
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="officer_address"
                                                placeholder="ঠিকানা"
                                                value={newRelatedLawOfficerName.officer_address}
                                                onChange={(e) => setNewRelatedLawOfficerName({
                                                    ...newRelatedLawOfficerName,
                                                    officer_address: e.target.value
                                                })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="submit-section">
                                        <button
                                            type="submit"
                                            className="btn caseButtonColor px-5 py-2 rounded"
                                        >
                                            যোগ করুন
                                        </button>

                                        <button
                                            type="button"
                                            className="btn caseButtonColor px-5 ms-1 py-2 rounded"
                                            data-dismiss="modal"
                                        >
                                            বন্ধ করুন
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ThreeMemberCaseUpdateForm;